<form [formGroup]="formGroup">
  @if (showLocation) {
    <app-row>
      <app-input
        label="MGRS"
        i18n-label="@@itemForm.mgrs"
        formControlName="mgrs"
        [required]="true"
        [touched]="formGroup.get('mgrs')?.touched"
        [errorMessage]="formGroup.get('mgrs')?.errors">
      </app-input>
    </app-row>
  }

  @for (item of identificationItems; track item.id; let i = $index) {
    <div class="identification-row">
      <app-input-mock
        label="{{ i > 0 ? '' : 'Possible Identification' }}"
        placeholder="Search..."
        i18n-placeholder="@@itemForm.searchPlaceholder"
        leftIcon="ri-search-line"
        rightIcon="ri-arrow-right-s-line"
        [value]="getPossibleIdentificationLabel(item)"
        (onClick)="editIdentification(item.id)"
        [required]="true"
        [errorMessage]="formGroup.get('possibleIdentification')?.errors"
        [touched]="formGroup.get('possibleIdentification')?.touched"
      ></app-input-mock>
      <div
        class="remove-item {{ i === 0 ? 'first' : '' }}"
        (click)="removeIdentification(item.id)"
      >
        &times;
      </div>
    </div>
  }

  <div class="add-item" (click)="addIdentificationItem()" i18n="@@itemForm.addItem">
    Add Item
  </div>

  <div *ngIf="deleteable" class="image-upload-section">
    <div class="image-upload-row">
      <div class="image-upload-col">
        <app-image-upload-dropzone
          label="Overall Images"
          i18n-label="@@overallImagesLabel"
          [maxImages]="2"
          [images]="overallImages"
          (imageSelected)="
            imagesAdd.emit({ tag: ImageTag.OVERALL, url: $event.url })
          "
          (deleteImage)="
            imagesDelete.emit({ tag: ImageTag.OVERALL, url: $event.url })
          "
          [required]="true"
          [errorMessage]="formGroup.get('overallImages')?.errors"
          [touched]="formGroup.get('overallImages')?.touched">
        </app-image-upload-dropzone>
      </div>
    </div>
    <div class="image-upload-row">
      <div class="image-upload-col">
        <app-image-upload-dropzone
          label="Nose Images"
          i18n-label="@@noseImagesLabel"
          [maxImages]="1"
          [images]="noseImages"
          (imageSelected)="
            imagesAdd.emit({ tag: ImageTag.NOSE, url: $event.url })
          "
          (deleteImage)="
            imagesDelete.emit({ tag: ImageTag.NOSE, url: $event.url })
          ">
        </app-image-upload-dropzone>
      </div>
    </div>

    <div class="image-upload-row">
      <div class="image-upload-col">
        <app-image-upload-dropzone
          label="Tail Images"
          i18n-label="@@tailImagesLabel"
          [maxImages]="1"
          [images]="tailImages"
          (imageSelected)="
            imagesAdd.emit({ tag: ImageTag.TAIL, url: $event.url })
          "
          (deleteImage)="
            imagesDelete.emit({ tag: ImageTag.TAIL, url: $event.url })
          ">
        </app-image-upload-dropzone>
      </div>
    </div>
  </div>
</form>

<app-ordnance-search-modal
  [visible]="showOrdnanceModal"
  [reportType]="reportType"
  (close)="onOrdnanceModalClose()"
  (select)="onOrdnanceSelect($event)">
</app-ordnance-search-modal>